import PageLayout from "@/components/PageLayout";
import PageHero from "@/components/PageHero";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import heroImg from "@/assets/hero/transferdruk.webp";
import imgTransfer from "@/assets/techniques/transferdruk.webp";
import imgDtf from "@/assets/techniques/dtf.webp";

const Transferdruk = () => (
  <PageLayout
    title="Transferdruk"
    metaDescription="Full color transferdruk bij Magic Print Den Haag: heldere kleuren en haarscherp resultaat op T-shirts, hoodies, tassen en bedrijfskleding."
    ogImage={heroImg}
    hero={
      <PageHero
        image={heroImg}
        alt="Transferdruk bij Magic Print"
        title="Fullcolour textiel transfers"
        subtitle="Heldere kleuren en een haarscherp resultaat op vrijwel ieder textiel."
      />
    }
  >


    <p className="text-lg text-muted-foreground mb-8 leading-relaxed">
      Wilt u t-shirts of een andere soort textiel laten bedrukken? Dan bent u bij Magic Print aan het juiste adres. Van t-shirts tot hoodies en van caps tot werkkleding: u kunt bij ons terecht voor al uw bedrukkingen en borduringen op textiel. Een van de mogelijkheden is transferdruk — een techniek die een aantal voordelen kent ten opzichte van andere druktechnieken.
    </p>

    <section className="mb-12 grid md:grid-cols-2 gap-8 items-center">
      <img
        src={imgTransfer}
        alt="Textiel transfers machine"
        loading="lazy"
        className="w-full h-auto rounded-2xl"
      />
      <div>
        <h2 className="text-2xl font-bold mb-4 text-[#0a2933]">Wat is transferdruk?</h2>
        <p className="text-muted-foreground">
          Transferdruk lijkt een beetje op zeefdruk. Waar de inkt bij{" "}
          <Link to="/druktechnieken/zeefdrukkerij" className="text-primary underline">zeefdruk</Link>{" "}
          direct op het t-shirt wordt aangebracht, gebeurt dit bij transferdruk door middel van een folie. Allereerst wordt het ontwerp in spiegelbeeld geprint op een plakkende folie. Deze folie brengen we vervolgens aan op het te bedrukken textiel. Het textiel wordt onder de pers geplaatst, welke de folie in zo'n 45 seconden onder druk en hoge temperatuur op het textiel drukt. Door de hitte wordt de lijm van de folie vloeibaar en hecht zich aan het textiel.
        </p>
      </div>
    </section>

    <section className="mb-12">
      <h2 className="text-2xl font-bold mb-4 text-[#0a2933]">Heldere kleuren en haarscherp resultaat</h2>
      <p className="text-muted-foreground">
        Transferdruk resulteert in heldere kleuren en een haarscherp resultaat. Dit komt doordat de opdruk eerst geprint wordt met een printer die overeenkomsten heeft met een reguliere printer. U kunt dus alle mogelijke kleuren gebruiken die u wilt, het ontwerp wordt immers digitaal geprint. De kleuren van een transferdruk worden bepaald met het zogenaamde CMYK kleurensysteem. Met deze vier basiskleuren — zwart, cyaan, magenta en geel — kan een zeer groot aantal kleuren gemengd worden.
      </p>
    </section>

    <section className="mb-12 grid md:grid-cols-2 gap-8 items-center">
      <div>
        <h2 className="text-2xl font-bold mb-4 text-[#0a2933]">Full color textiel bedrukken</h2>
        <p className="text-muted-foreground mb-6">
          Wanneer u textiel in full color wilt bedrukken is transferdruk wellicht de beste keuze. Deze druktechniek leent zich perfect voor het drukken van foto's en andere personalisaties. Transferdruk is het voordeligst bij grotere oplages, omdat het proces vrij arbeidsintensief is — er moet tenslotte voor ieder product een nieuwe folie worden geprint. Wilt u kleinere oplages textiel in full color laten bedrukken? Kies dan voor{" "}
          <Link to="/druktechnieken/dtf-printing" className="text-primary underline">DTF printing</Link>. Uiteraard zullen wij u altijd adviseren over de opties en welke druktechniek het beste bij uw bestelling past.
        </p>
      </div>
      <img
        src={imgDtf}
        alt="Full color textiel bedrukken"
        loading="lazy"
        className="w-full h-auto rounded-2xl bg-white"
      />
    </section>

    <section className="mb-12">
      <h2 className="text-2xl font-bold mb-4 text-[#0a2933]">Kleding bedrukken met textieltransfers?</h2>
      <p className="text-muted-foreground mb-6">
        Wilt u kleding laten bedrukken door middel van textieltransfers? Vraag dan vrijblijvend een prijsvoorstel aan. Bij vragen kunt u uiteraard contact met ons opnemen door te bellen naar{" "}
        <a href="tel:+31708873306" className="text-primary underline">070-8873306</a>{" "}of een e-mail te sturen naar{" "}
        <a href="mailto:info@magicprint.nl" className="text-primary underline">info@magicprint.nl</a>.
      </p>
      <Button asChild>
        <Link to="/offerte">Vraag een offerte aan</Link>
      </Button>
    </section>
  </PageLayout>
);

export default Transferdruk;
